import clsx from 'clsx';
import { Dispatch, ReactNode, SetStateAction, forwardRef } from 'react';
import { MenuConfig } from 'alurkerja-ui';
import ListMenu from './ListMenu';

export interface SidebarProps {
  logo: ReactNode;
  menuConfig: MenuConfig[];
  toggled: boolean;
  setToggled: Dispatch<SetStateAction<boolean>>;
  width?: string | number;
  currentPathName?: string;
  className?: string;
  children?: ReactNode;
  menuWrapper?: ({ children, menu }: { children: JSX.Element; menu: MenuConfig }) => JSX.Element;
}

const Sidebar = forwardRef<HTMLDivElement, SidebarProps>((props, ref) => {
  const { logo, menuConfig, toggled, className, setToggled, currentPathName, menuWrapper, children, ...rest } = props;

  return (
    <div
      className={clsx(
        'h-screen z-50 top-0 transition-[width,margin] border-r ease-in-out duration-400 bg-[#FAFAFA] relative pt-5',
        !toggled ? 'w-60' : '-ml-60 md:ml-0 md:w-20',
        className,
      )}
      ref={ref}
      {...rest}
    >


      {/* Menu */}
      <div className="h-[calc(100vh-8rem)]  overflow-y-auto scrollbar-thin scrollbar-track-[#FAFAFA] scrollbar-thumb-gray-300 scrollbar-thumb-rounded scrollbar-track-rounded">
        <div className="w-full h-full">

          {/* <div className={clsx(
              'flex items-center justify-between px-4 mb-4',
              toggled ? 'md:justify-center mr-3 w-[42]' : 'md:justify-between',
            )} >
              {!toggled && <>
              
              <div >
                <input className="border border-gray-300 rounded-md p-2 w-[180px]" placeholder="Search..." />
              </div>
</>}
              
              <button
                onClick={() => setToggled(prev => !prev)}
                className={clsx(
                  ' top-2 transition-all duration-300 p-1 hover:bg-gray-100 ',
                  toggled ? 'w-30' : 'w-10',
                )}
              >
                <div className={clsx('transition-transform duration-300', toggled && 'rotate-180')}>
                  <PanelLeft size={18} />
                </div>
              </button> */}
          {/* </div> */}
          {children}
          <ListMenu
            menuConfig={menuConfig}
            toggled={toggled}
            currentPathName={currentPathName}
            menuWrapper={menuWrapper}
          />
        </div>
      </div>
    </div>
  );
});

export default Sidebar;
